import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from './connect';
import ReactTable from 'react-table';
import { Row, Col, Button, ButtonGroup, DropdownButton, MenuItem, SplitButton } from 'react-bootstrap';
import * as Api from 'api';
import Table from './table';
import { Link } from 'react-router';

class SectionTable extends Component {
  componentDidMount() {

  }
  render() {
    const { section_manager } = this.props;
    return (
      <Table
        {...section_manager}
        showToolbar
        onFetch={options => this.props.fetchSections({
          ...(options || {}),
          // populate: 'template'
        })}
        columns={[
          { header: '', width: 100, render: ({ value, row }) => (
            <Link className='btn btn-block' to={`/sales-site/sections/${row._id}`} block><i className='fa fa-pencil'></i></Link>
          )},
          { header: 'Path', accessor: 'path' },
          { header: 'Title', accessor: 'title' },
          { header: 'Tags', accessor: 'tags' },
          { header: 'Author', accessor: 'author' },
          { header: 'Details', accessor: 'details' },
          { header: 'Creator', accessor: 'creator' },
          { header: 'Last Editor', accessor: 'last_editor' },
          { header: 'Description', accessor: 'description' },
          { header: 'Date Last Edited', accessor: 'edited_timestamp' },
          { header: 'Date Created', accessor: 'created_timestamp' },
          { header: 'Published', accessor: 'published' },
          { header: 'Date Published', accessor: 'published_timestamp'}
        ]}
        selected_columns={['path', 'title', 'tags', 'author']}
      />
    );
  }
}

export default connect(SectionTable);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/section-table.js